var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.92,
    height: 23.716,
    viewBox: "0 0 27.92 23.716",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1282",
    "data-name": "Grupo 1282",
    transform: "translate(0.707 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6978",
    "data-name": "Trazado 6978",
    d: "M875.09-752.147A10.854,10.854,0,0,1,885.943-763a10.853,10.853,0,0,1,9.637,5.856",
    transform: "translate(-872.681 763)",
    fill: "rgba(0,0,0,0)",
    stroke: "#484960",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6979",
    "data-name": "Trazado 6979",
    d: "M869.057-719.682l-2.528,2.528L864-719.682",
    transform: "translate(-864 729.093)",
    fill: "rgba(0,0,0,0)",
    stroke: "#484960",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6980",
    "data-name": "Trazado 6980",
    d: "M901.089-713a10.854,10.854,0,0,1-10.854,10.853A10.853,10.853,0,0,1,880.6-708",
    transform: "translate(-876.992 723.863)",
    fill: "rgba(0,0,0,0)",
    stroke: "#484960",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6981",
    "data-name": "Trazado 6981",
    d: "M962.726-715.472,965.254-718l2.528,2.528",
    transform: "translate(-941.277 727.777)",
    fill: "rgba(0,0,0,0)",
    stroke: "#484960",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refreshIcon.875f816bced637ba84f398c6115127f1.svg";
export { ForwardRef as ReactComponent };